function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.58",
  height: "16",
  viewBox: "0 0 14.58 16",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.37 5.43L7.5.11a.53.53 0 00-.65 0L.2 5.45a.53.53 0 00-.2.4v9.63a.53.53 0 00.53.53h3.95a.53.53 0 00.53-.53V9.58h4.56v5.9a.53.53 0 00.53.52h3.95a.53.53 0 00.53-.53V5.85a.53.53 0 00-.2-.42z"
})));